// extracted by mini-css-extract-plugin
module.exports = {"show":"seoIndex-module__show___lNXCJ","hidden":"seoIndex-module__hidden___GHZub","page_desc":"seoIndex-module__page_desc___uhDnb"};